import uuid from 'time-uuid'

import type { Order } from '@/data/Order'
import { OrderStatus } from '@/pos/OrderType'
import { signalSyncedWithLocalStorage } from '@/react/core/reactive'

import { completeOrder } from '../order-mutations'
import { srmTransactionLogic } from '../transaction.logic'
import { execTestcase, getCaTaxInfo } from './libs'

type O = Readonly<Order>

const [order01, setOrder01] = signalSyncedWithLocalStorage<O | null>('TESTCASE_020_ORDER_01', null)

export const testRunner020: Record<string, () => Promise<boolean>> = {
  '020.001': () =>
    execTestcase({
      num: 20,
      step: 1,
      device: 'A',
      run: async () => {
        const taxInfo = getCaTaxInfo()
        const baseOrder: O = {
          _id: uuid(),
          table: '020',
          status: OrderStatus.IN_PROGRESS,
          payments: [],
          items: [
            // Main Course
            { name: 'Bouillabaisse', price: 22, quantity: 1, modifiers: [], ...taxInfo },
            { name: 'Poutine', price: 33, quantity: 1, modifiers: [], ...taxInfo },
            // Drink
            { name: 'Bordeaux', price: 18, quantity: 1, modifiers: [], ...taxInfo },
            { name: 'Sortilège', price: 28, quantity: 1, modifiers: [], ...taxInfo },
            // Dessert
            { name: 'Crème Brûlée', price: 6.5, quantity: 1, modifiers: [], ...taxInfo },
            { name: 'Tarte Tatin', price: 8, quantity: 1, modifiers: [], ...taxInfo },
          ],
        }
        const order01: O = { ...baseOrder, seat: 0, _id: uuid(), items: [...baseOrder.items.filter((_, i) => i % 2 === 0)] }
        const order02: O = { ...baseOrder, seat: 1, _id: uuid(), items: [...baseOrder.items.filter((_, i) => i % 2 === 1)] }
        const groupedOrder: O = { ...baseOrder, seatMap: [order01, order02] }
        setOrder01(groupedOrder)

        await srmTransactionLogic.recordTemporaryBill(order01, { print: true })
      },
    }),
  '020.002': () =>
    execTestcase({
      num: 20,
      step: 2,
      device: 'A',
      run: async () => {
        const o = order01()
        if (!o) throw new Error('Please run step 1 first')
        const order = o.seatMap?.[1]
        if (!order) throw new Error('Seat 1 not found')
        await srmTransactionLogic.recordTemporaryBill(order, { print: true })
      },
    }),
  '020.003': () =>
    execTestcase({
      num: 20,
      step: 3,
      device: 'A',
      run: async () => {
        const o = order01()
        if (!o) throw new Error('Please run step 1 first')
        await srmTransactionLogic.recordTemporaryBill(o, { print: true })
      },
    }),
  '020.004': () =>
    execTestcase({
      num: 20,
      step: 4,
      device: 'A',
      run: async () => {
        const o = order01()
        if (!o) throw new Error('Please run step 1 first')
        await srmTransactionLogic.recordClosingReceipt(completeOrder(o), { print: true })
      },
    }),
}
